import { type Dispatch } from '@reduxjs/toolkit';
import { type SnakeToCamelCaseKeys } from '@repo/utils';
import { CaseUtil } from '@vectord/utils';
import { NodeType } from 'automations/data/nodeTypes';
import { type SavedNodeResponseType } from 'automations/services/nodeService';
import { addAdditionalOptions, addNodeWithPosition } from 'automations/store/reactFlowSlice';
import { ConditionTypes } from 'automations/types/automationConfig';
import { type ElseNodeType, type IfNodeType } from 'automations/types/nodeTypes';

export function updateMultiIfElseNodeCreate(response: SavedNodeResponseType) {
  return (dispatch: Dispatch<any>) => {
    const nodeData = CaseUtil.toCase('camelCase', response) as SnakeToCamelCaseKeys<typeof response>;
    const multiIfElseNode = nodeData.node;
    const ifNode = nodeData.childNodes[0];
    const elseNode = nodeData.childNodes[1];

    if (multiIfElseNode?.id) {
      dispatch(addAdditionalOptions({
        nodeId: multiIfElseNode.id,
        additionalOptions: {},
      }));

      if (ifNode?.id) {
        const newNode: IfNodeType = {
          id: ifNode.id,
          type: NodeType.condition,
          data: {
            ...ifNode,
            nodeSubType: ConditionTypes.if,
            additionalOptions: {
              criteriaGroupId: ifNode.additionalOptions?.criteriaGroupId as number,
            },
          },
          position: { x: 0, y: 0 },
        };
        dispatch(addNodeWithPosition({
          newNode,
          sourceNodeId: multiIfElseNode.id.toString(),
        }));
      }

      if (elseNode?.id) {
        const newNode: ElseNodeType = {
          id: elseNode.id,
          type: NodeType.condition,
          data: {
            ...elseNode,
            nodeSubType: ConditionTypes.else,
          },
          position: { x: 0, y: 0 },
        };
        dispatch(addNodeWithPosition({
          newNode,
          sourceNodeId: multiIfElseNode.id.toString(),
        }));
      }
    }
  };
}
